import GenericListModule from "../generic-list-module";

export default class SelectionManager {

    public module       : GenericListModule
    private _value      : any[]

    constructor(module:GenericListModule, currentValue:any=[]) {
        this.module = module;
        this._value = currentValue ? Array.isArray(currentValue) ? currentValue : [currentValue] : [];
    }

    setSelectedSingle(selectedId:ID) {
        this._value = [selectedId];
        // this.module.data.process();
        this.module.reRender();
    }

    getSelected() {
        return this._value || [];
    }

    isSelected(id:ID) {
        return this.getSelected().includes(id);
    }
}